import { render, staticRenderFns } from "./languagePreview.vue?vue&type=template&id=004167c0&scoped=true&"
import script from "./languagePreview.vue?vue&type=script&lang=js&"
export * from "./languagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004167c0",
  null
  
)

export default component.exports